import React, { useState, useEffect } from 'react';
import { Alert, Card, Form } from 'react-bootstrap';
import { HHIEButton } from './utility/HHIEButton';
import { HHIECard } from './utility/HHIECard';
import { HHIEError } from './utility/HHIEError';
import { HHIEPasswordRequirements } from './utility/HHIEPasswordRequirements';
import Loading from './utility/Loading';

export const ResetTempPassword = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMessage] = useState();
    const [success, setSuccess] = useState(false);
    const [pocid, setPOCID] = useState();
    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [pwdLength, setPwdLength] = useState();

    useEffect(() => {
        setLoading(true);
        try {
            const user = JSON.parse(sessionStorage.getItem("user"));
            if (user === null) {
                handleError("You must be associated with an account for this portion.");
                setTimeout(() => { window.location.href = '/login' }, 3000);
                return;
            }
            if (user.pocid === 0) {
                handleError("You must be associated with an account for this portion.");
                setTimeout(() => { window.location.href = '/login' }, 3000);
                return;
            }
            if (!user.securityQuestionsComplete) {
                handleError("You need to complete your security questions.");
                setTimeout(() => { window.location.href = '/set-security-questions' }, 3000);
                return;
            }
            if (!user.passwordIsTemporary) {
                handleError("You've already reset your password, please login.");
                setTimeout(() => { window.location.href = '/login' }, 3000);
                return;
            }
            setPOCID(user.pocid);
        }
        catch (ex) {
            console.log(ex);
        }
        // get password length from db
        fetch('api/login/required-pwd-length')
            .then(response => {
                response.json()
                    .then(passwordLength => {
                        if (passwordLength.errors !== null && passwordLength.errors !== "") alert(passwordLength.errors)
                    setPwdLength(passwordLength.message);
                })
                .catch(ex => {
                    console.log(ex);
                });
            })
            .catch(ex => {
                console.log(ex);
            });
        setLoading(false);
    }, []);

    const handleError = (message) => {
        setError(true);
        setErrorMessage(message);
    }
    // pw validators
    const checkForUpperCase = (word) => hasCharacter(/^[A-Z]+$/, word);
    const checkForLowerCase = (word) => hasCharacter(/^[a-z]+$/, word);
    const checkForNumber = (word) => hasCharacter(/^[0-9]+$/, word);
    const checkForSymbol = (word) => hasCharacter(/[-!@#$%^&*()_+=/\u0020]/, word);
    const checkForNonCompliantSymbol = (word) => hasCharacter(/[^A-Za-z0-9-!@#$%^&*()_+=/\u0020]/, word);
    const hasCharacter = (regex, word) => {
        let hasCharacter = false;
        if (word.length > 0) {
            for (var i = 0; i<word.length; i++) {
                var letter = word.charAt(i);
                if (letter.match(regex)) {
                    hasCharacter = true;
                    break;
                }
            }
        }
        return hasCharacter;
    };
    // SUBMIT
    const handleSubmit = async () => {
        const pwd = password ? password : "";
        const conPwd = confirmPassword ? confirmPassword : "";

        if (pwd === conPwd) {
            if (pwd.length >= pwdLength 
                && checkForLowerCase(pwd)
                && checkForUpperCase(pwd) 
                && checkForNumber(pwd) 
                && checkForSymbol(pwd)
                && !checkForNonCompliantSymbol(pwd))
            {
                const formData = new FormData();
                if (pocid === null || pocid === 0) {
                    handleError("Something went wrong. Please contact the HHIE.");
                    return;
                }
                formData.append("pocid", pocid);
                formData.append("password", password);
                formData.append("temporaryPassword", sessionStorage.getItem("temporaryVerification"));

                const requestOptions = {
                    method: 'POST',
                    body: formData
                }
                const success = await fetch('api/POCUser/reset-poc-temp-password', requestOptions)
                    .then(async (response) => {
                        try {
                            const res = await response.json().then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors)
                                return json.message
                            });
                            return res;
                        }
                        catch (ex) {
                            handleError(ex);
                            return console.log(ex);
                        }
                    })
                    .catch(ex => console.log(ex));
                if (success) {
                    setSuccess(true);
                    setError(false);
                    sessionStorage.removeItem("temporaryVerification");
                    sessionStorage.clear();
                }
                else {
                    setErrorMessage("Bad Password. Try again.");
                }
            } else {
                handleError("Invalid Password. Please check password requirements above.");
            }
        } else {
            handleError("Passwords do not match. Try again.");
        }
        
    };
    
    return (
        <>
            {loading && <Loading message="Please wait while we load your information..." />}
            {!loading &&
                <HHIECard>
                    {!success && 
                    <>
                        <Card.Title>Please create a new secure password.</Card.Title>
                        <HHIEPasswordRequirements 
                            pwdLength={pwdLength} 
                            password={password} 
                            confirmPassword={confirmPassword}
                        />
                        <hr />
                        <Form>
                            <Form.Group key="set-password">
                                <Form.Label>Set Your Password</Form.Label>
                                <Form.Control
                                    id="set-password"
                                    type="password"
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                    }}
                                />
                                <br />
                                <Form.Label>Confirm Your Password</Form.Label>
                                <Form.Control
                                    id="set-confirm-password"
                                    type="password"
                                    onChange={(e) => {
                                        setConfirmPassword(e.target.value);
                                    }}
                                />
                                <br />
                                <HHIEButton
                                    id="reset-pwd-btn"
                                    title="Reset Password"
                                    onClick={handleSubmit}
                                // disabled={(password === "" && confirmPassword === "")} 
                                />
                            </Form.Group>
                        </Form>
                        {error &&
                            <HHIEError message={errorMsg} onClick={() => { setError(false); setErrorMessage(""); }} />
                        }
                    </>}
                    {success &&
                        <Alert variant="success">You have successfully reset your password, please <Alert.Link href="/login">login</Alert.Link> with your new password.</Alert>
                    }
                </HHIECard>
            }
        </>
    );
}